import type { Dict } from "../types";

export const workShifts: Dict = {
  en: {
    "WorkShifts.headerSubtitle": "Punch in/out, day finalization and employee PINs.",
    "WorkShifts.tabPunch": "Punch",
    "WorkShifts.tabFinalize": "Finalization",
    "WorkShifts.tabEmployeesTab": "Employees",
    "WorkShifts.tileEmployees": "Employees",
    "WorkShifts.tileMissingPin": "Missing PINs",
    "WorkShifts.tileFinalized": "Day",
    "WorkShifts.tileFinalizedYes": "Finalized",
    "WorkShifts.tileFinalizedNo": "To do",
    "WorkShifts.tilePeriod": "Period",
    "WorkShifts.periodDay": "Day",
    "WorkShifts.periodWeek": "Week",
    "WorkShifts.periodBiweek": "Biweekly",
    "WorkShifts.periodMonth": "Month",
    "WorkShifts.finalize.selectDay": "Select the \"Day\" filter to finalize a day.",
    "WorkShifts.title": "Work Shifts",
    "WorkShifts.subtitle": "Track and close employee shifts",
    "WorkShifts.punchInOut": "Punch In / Out",
    "WorkShifts.punchInOutDesc": "Enter your personal PIN to punch in or out.",
    "WorkShifts.pinManagement": "PIN Management",
    "WorkShifts.pinManagementDesc": "Manage employee punch clock PINs.",
    "WorkShifts.myShifts": "My Shifts",
    "WorkShifts.period.day": "Day",
    "WorkShifts.period.week": "Week",
    "WorkShifts.period.biweek": "2 weeks",
    "WorkShifts.period.month": "Month",
    "WorkShifts.period.previous": "Previous period",
    "WorkShifts.period.next": "Next period",
    "WorkShifts.alreadyPunchedIn": "You are already punched in. Please punch out first.",
    "WorkShifts.timesheetUnchanged": "Punch out saved at {time}. The timesheet did not change: this day is already finalized, or its payroll is locked.",
    "WorkShifts.punchOtherFiche": "This PIN belongs to another employee. From your own session you can only clock yourself in and out. Ask the salon owner to open the shared clock.",
    "WorkShifts.finalize.button": "Finalize day",
    "WorkShifts.finalize.modify": "Edit",
    "WorkShifts.finalize.dialogTitle": "Finalize day {date}",
    "WorkShifts.finalize.dialogDescription": "Review and adjust each employee's worked hours, then confirm to record them.",
    "WorkShifts.finalize.confirm": "Confirm",
    "WorkShifts.finalize.cancel": "Cancel",
    "WorkShifts.finalize.addEmployee": "+ Add employee",
    "WorkShifts.finalize.startTime": "Start",
    "WorkShifts.finalize.endTime": "End",
    "WorkShifts.finalize.lunch": "Lunch (min)",
    "WorkShifts.finalize.break": "Breaks (min)",
    "WorkShifts.finalize.notes": "Notes",
    "WorkShifts.finalize.origineEntree": "Recorded",
    "WorkShifts.finalize.originePoincon": "Clocked",
    "WorkShifts.finalize.origineHoraire": "Scheduled, not clocked",
    "WorkShifts.finalize.origineAjout": "Added",
    "WorkShifts.finalize.finalizedBadge": "Finalized on {date} at {time} by {by}",
    "WorkShifts.finalize.success": "Day finalized",
    "WorkShifts.finalize.invalidTimes": "End time must be after start time",
    "WorkShifts.finalize.lunchBreakExceedsTotal": "Lunch + breaks cannot exceed total work duration",
    // On n'affiche pas la fréquence réelle du salon : ce serait une requête de
    // plus, sur la table d'un autre module, pour un gain nul. Ce qui compte est
    // que ces lignes sont verrouillées, pas le nom du cycle qui les verrouille.
    "WorkShifts.finalize.lockedByPayroll": "{count} employee(s) have their payroll finalized for this date. Their rows are read only.",
    "WorkShifts.finalize.forgottenToday": "{count} forgotten punch-out(s) today. Adjust end times below.",
    "WorkShifts.finalize.invalidHours": "Invalid hours",
    "WorkShifts.finalize.hoursWorked": "{duration} worked",
    "WorkShifts.finalize.noPunchesToday": "No employee punched on this day.",
    "WorkShifts.finalize.removeRow": "Remove",
    "WorkShifts.finalize.notesPlaceholder": "Optional",
    "WorkShifts.finalize.searchEmployee": "Search employee...",
    "WorkShifts.finalize.noResults": "No results",
    "WorkShifts.finalize.notYetFinalized": "This day hasn't been finalized yet.",
    "WorkShifts.noAccessTitle": "No access",
    "WorkShifts.noAccessDescription": "You do not have permission to view work shifts. Contact the salon owner to request access.",
    "WorkShifts.punchNotAllowed": "You do not have permission to punch in or out.",
    "WorkShifts.finalizeNotAllowed": "You do not have permission to finalize the day.",
  },
  fr: {
    "WorkShifts.headerSubtitle": "Pointage, finalisation et NIP des employés.",
    "WorkShifts.tabPunch": "Pointage",
    "WorkShifts.tabFinalize": "Finalisation",
    "WorkShifts.tabEmployeesTab": "Employés",
    "WorkShifts.tileEmployees": "Employés",
    "WorkShifts.tileMissingPin": "NIP manquants",
    "WorkShifts.tileFinalized": "Journée",
    "WorkShifts.tileFinalizedYes": "Finalisée",
    "WorkShifts.tileFinalizedNo": "À faire",
    "WorkShifts.tilePeriod": "Période",
    "WorkShifts.periodDay": "Jour",
    "WorkShifts.periodWeek": "Semaine",
    "WorkShifts.periodBiweek": "Quinzaine",
    "WorkShifts.periodMonth": "Mois",
    "WorkShifts.finalize.selectDay": "Sélectionnez le filtre « Jour » pour finaliser une journée.",
    "WorkShifts.title": "Quarts de travail",
    "WorkShifts.subtitle": "Suivre et fermer les quarts de travail des employés",
    "WorkShifts.punchInOut": "Pointer entrée/sortie",
    "WorkShifts.punchInOutDesc": "Entrez votre NIP personnel pour pointer votre arrivée ou départ.",
    "WorkShifts.pinManagement": "Gestion des NIP",
    "WorkShifts.pinManagementDesc": "Gérer les NIP de pointage des employés.",
    "WorkShifts.myShifts": "Mes quarts",
    "WorkShifts.period.day": "Jour",
    "WorkShifts.period.week": "Semaine",
    "WorkShifts.period.biweek": "2 semaines",
    "WorkShifts.period.month": "Mois",
    "WorkShifts.period.previous": "Période précédente",
    "WorkShifts.period.next": "Période suivante",
    "WorkShifts.alreadyPunchedIn": "Vous êtes déjà pointé. Veuillez d'abord pointer votre sortie.",
    "WorkShifts.timesheetUnchanged": "Sortie enregistrée à {time}. La feuille de temps n'a pas changé : cette journée est déjà finalisée, ou sa paie est verrouillée.",
    "WorkShifts.punchOtherFiche": "Ce NIP est celui d'un autre employé. Depuis votre propre session, vous ne pouvez pointer que vous-même. Demandez au propriétaire du salon d'ouvrir la pointeuse partagée.",
    "WorkShifts.finalize.button": "Finaliser la journée",
    "WorkShifts.finalize.modify": "Modifier",
    "WorkShifts.finalize.dialogTitle": "Finaliser la journée du {date}",
    "WorkShifts.finalize.dialogDescription": "Vérifiez et ajustez les heures travaillées de chaque employé, puis confirmez pour les enregistrer.",
    "WorkShifts.finalize.confirm": "Confirmer",
    "WorkShifts.finalize.cancel": "Annuler",
    "WorkShifts.finalize.addEmployee": "+ Ajouter un employé",
    "WorkShifts.finalize.startTime": "Entrée",
    "WorkShifts.finalize.endTime": "Sortie",
    // Same two DB fields as Payroll.lunch / Payroll.break above; keep the wording
    // identical across both dialogs so the columns read as the same thing.
    "WorkShifts.finalize.lunch": "Dîner (min)",
    "WorkShifts.finalize.break": "Pauses (min)",
    "WorkShifts.finalize.notes": "Notes",
    "WorkShifts.finalize.origineEntree": "Enregistré",
    "WorkShifts.finalize.originePoincon": "Pointé",
    "WorkShifts.finalize.origineHoraire": "Horaire prévu, non pointé",
    "WorkShifts.finalize.origineAjout": "Ajouté",
    "WorkShifts.finalize.finalizedBadge": "Finalisée le {date} à {time} par {by}",
    "WorkShifts.finalize.success": "Journée finalisée",
    "WorkShifts.finalize.invalidTimes": "L'heure de sortie doit être après l'entrée",
    // « Dîner », pas « Lunch » : c'est le nom du champ juste au dessus.
    "WorkShifts.finalize.lunchBreakExceedsTotal": "Le dîner et les pauses ne peuvent pas dépasser la durée totale travaillée",
    // On n'affiche pas la fréquence réelle du salon : ce serait une requête de
    // plus, sur la table d'un autre module, pour un gain nul. Ce qui compte est
    // que ces lignes sont verrouillées, pas le nom du cycle qui les verrouille.
    "WorkShifts.finalize.lockedByPayroll": "{count} employé(s) ont leur paie finalisée pour cette date. Leurs lignes sont en lecture seule.",
    "WorkShifts.finalize.forgottenToday": "{count} pointage(s) de sortie oublié(s) ce jour. Ajustez les heures de sortie ci-dessous.",
    "WorkShifts.finalize.invalidHours": "Heures invalides",
    "WorkShifts.finalize.hoursWorked": "{duration} travaillées",
    "WorkShifts.finalize.noPunchesToday": "Aucun employé n'a pointé ce jour.",
    "WorkShifts.finalize.removeRow": "Supprimer",
    "WorkShifts.finalize.notesPlaceholder": "Optionnel",
    "WorkShifts.finalize.searchEmployee": "Rechercher un employé...",
    "WorkShifts.finalize.noResults": "Aucun résultat",
    "WorkShifts.finalize.notYetFinalized": "Cette journée n'a pas encore été finalisée.",
    "WorkShifts.noAccessTitle": "Accès refusé",
    "WorkShifts.noAccessDescription": "Vous n'avez pas la permission de voir les quarts de travail. Contactez le propriétaire du salon pour demander l'accès.",
    "WorkShifts.punchNotAllowed": "Vous n'avez pas la permission de pointer votre arrivée ou départ.",
    "WorkShifts.finalizeNotAllowed": "Vous n'avez pas la permission de finaliser la journée.",
  },
};
